import React, { useState } from 'react'

import internalApiQueryWrapper from '../../core/internalApiQueryWrapper'
import authorPage from '../../styles/components/authorPage/author_page'
import verticalCard from '../../styles/components/authorPage/verticalCard'
import { structure } from '../../styles/global'
import BaseCSS from '../../styles/global/BaseCSS'
import AdUnit from '../Ads/AdUnit'
import Card from '../Category/Card'
import LoadMoreButton from '../Category/LoadMoreButton'
import Loading from '../Loading'
import Metadata from '../Metadata'
import UnresetCSS from '../UnresetCSS'
import AuthorInfo from './AuthorInfo'

const Author = ({ author, storiesData = { stories: [], total: 0 }, metadata }) => {
  const [collection, setCollection] = useState(storiesData.stories)
  const [loading, setLoading] = useState(false)

  const loadMore = async () => {
    setLoading(true)
    const data = await internalApiQueryWrapper('/api/contentful/collection', {
      authorId: author.id,
      skip: collection.length,
      order: '-fields.publishedAt',
      limit: 6,
      'fields.indexed[nin]': false
    })

    setLoading(false)
    setCollection([...collection, ...data.stories])
  }

  return (
    <div className='main-layout-container'>
      <div className='main-layout' data-testid='author'>
        <Metadata metadata={metadata} />
        <AdUnit adUnitTemplate='leaderboard' id={'ad-banner-top'} type='leaderboardNew' />
        <AuthorInfo author={author} />
        <div />
        <div className='divider' />
        <div className='cards-grid'>
          {!collection?.length ? (
            <Loading />
          ) : (
            collection?.map(story => <Card key={story.id} story={story} style={verticalCard} />)
          )}
        </div>
        {storiesData?.total > collection.length && (
          <LoadMoreButton loading={loading} loadMore={loadMore} byline={author.byline} />
        )}
      </div>
      <div className='main-layout-sidebar'>
        <AdUnit adUnitTemplate='rectangleVertical' id={'ad-banner-sidebar-top'} type='homePageSidebar' />
      </div>
      <style jsx>{authorPage}</style>
      <style jsx global>
        {structure}
      </style>
      <UnresetCSS />
      <BaseCSS />
    </div>
  )
}

export default Author
